{
  "EMOJI": {
    "PLACEHOLDER": "Emojis durchsuchen",
    "NOT_FOUND": "Kein Emoji entspricht deiner Suche",
    "REMOVE": "Entfernen"
  }
}
